import { useAuth } from '../hooks/useAuth';
import styles from './UserBadge.module.css';

export function UserBadge() {
  const { user, logout } = useAuth();
  if (!user) return null;

  return (
    <div className={styles.badge}>
      <span className={styles.name}>{user.name}</span>
      <button onClick={logout} className={styles.logout}>
        Log out
      </button>
    </div>
  );
}
